import MixpanelTracker from '../mixpanelTracker';
import Action from '../Model/action';
import { ON_LANDING_EVENT_PAGE } from '../mixpanelConstants';

const mixpanelTracker = new MixpanelTracker();

export function onLandingOfEventPageTracker(eventData) {
  const properties = {
    Action: Action.VIEW,
    eventData,
  };
  mixpanelTracker.setEventName(ON_LANDING_EVENT_PAGE);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}
